export default function Packages() {
    return (
        <section
            id="packages"
            className="relative px-6 md:px-10 py-16 md:py-24 bg-[#F1E8D5]"
            data-testid="packages-section"
        >
            <div className="max-w-7xl mx-auto">
                {/* Total investment banner */}
                <div
                    className="relative bg-[#0A0A0A] text-white rounded-3xl p-8 md:p-10 border-2 border-black shadow-[8px_8px_0_0_#C2410C] reveal overflow-hidden"
                    data-testid="journey-total"
                >
                    <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-[#C2410C] opacity-25 blur-3xl" aria-hidden />
                    <div className="relative grid md:grid-cols-12 gap-6 items-center">
                        <div className="md:col-span-5">
                            <div className="font-mono text-[10px] uppercase tracking-widest font-bold text-[#D4A017]">
                                Total investment
                            </div>
                            <div className="mt-2 font-display font-black tracking-tighter text-6xl md:text-7xl leading-none">
                                &pound;199.97
                            </div>
                        </div>
                        <div className="md:col-span-7 text-white/85 text-base md:text-lg leading-relaxed">
                            <p>
                                You&rsquo;ll never be asked to pay everything upfront.
                                You simply pay each stage as your journey progresses.
                            </p>
                            <p className="mt-3">
                                Your My First Single vocal coach manages everything for
                                you &mdash; making the experience straightforward,
                                enjoyable and completely transparent.
                            </p>
                            <div className="mt-4 flex flex-wrap gap-2">
                                <span className="px-3 py-1 rounded-full border-2 border-white/30 text-xs font-medium">
                                    No hidden costs
                                </span>
                                <span className="px-3 py-1 rounded-full border-2 border-white/30 text-xs font-medium">
                                    No confusing packages
                                </span>
                                <span className="px-3 py-1 rounded-full border-2 border-[#D4A017] bg-[#D4A017] text-black text-xs font-bold">
                                    Just one unforgettable journey
                                </span>
                            </div>
                            <p className="mt-5 text-white/80 text-[14px] leading-relaxed">
                                You pay for each stage of the production
                                journey directly to your vocal coach, and they
                                remain your point of contact throughout your
                                journey.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
